module.exports = __webpack_public_path__ + "static/img/dynamicl.2d87921.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicl.png
// module id = 8oES
// module chunks = 45